import { FC } from 'react'

import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'
import { PerformanceProcessAgreementHeaderFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import { useActions } from './useActions'

export const ReviewProcessAgreementHeader: FC<{
  agreement: PerformanceProcessAgreementHeaderFragment
}> = ({ agreement }) => {
  const reviewer = agreement.managerEvaluation?.reviewerAccess
  const target = agreement.target.access

  const { primaryAction, secondaryActions } = useActions(agreement)

  return (
    <ResourceHeader
      title={i18n.t('performance_process.agreements.page.title')}
      description={i18n.t('performance_process.agreements.page.description')}
      primaryAction={primaryAction}
      secondaryActions={secondaryActions}
      metadata={[
        {
          label: i18n.t('performance_process.reviews.common.evaluator'),
          value: {
            type: 'avatar',
            text: reviewer?.fullName || '',
            variant: {
              src: buildUrl(reviewer?.avatar),
              firstName: reviewer?.firstName || '',
              lastName: reviewer?.lastName || '',
              type: 'person',
            },
          },
        },
        {
          label: i18n.t('performance_process.reviews.common.evaluated'),
          value: {
            type: 'avatar',
            text: target?.fullName || '',
            variant: {
              src: buildUrl(target?.avatar),
              firstName: target?.firstName || '',
              lastName: target?.lastName || '',
              type: 'person',
            },
          },
        },
      ]}
    />
  )
}
